import {Component, OnInit} from '@angular/core';
import {FormGroup, FormsModule, Validators} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Service d'auth
import {AuthService} from '../../services/auth.service';

import { HttpClientModule } from '@angular/common/http';

import { MatSnackBar } from '@angular/material/snack-bar';
import {RouterModule} from '@angular/router';
import {NavbarComponent} from '../../components/navbar/navbar.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    RouterModule,
    NavbarComponent
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AuthService],
})
export class LoginComponent {
  email = '';
  password = '';

  public isLoading = false;

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
  ) {
  }

  login() {
    this.isLoading = true;
    this.authService.login(this.getFormValues())
      .subscribe(
        (res) => {
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.snackBar.open('Une erreur est survenue lors de la connexion', 'Fermer', {
            duration: 3000,
          });

          this.password = '';
        },
      );
  }

  getFormValues(): { email: string; password: string } {
    return { email: this.email, password: this.password };
  }
}
